// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__IBBg6","avatar":"style_avatar__AlDuq"};